export default "__VITE_ASSET__q8l3eEPx__"